import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { HashRouter } from "react-router-dom";
import RoutingFile from './RoutingFile';
import reportWebVitals from './reportWebVitals';
import TawkTracker from "./TawkTracker";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <TawkTracker />
      <RoutingFile />
    </HashRouter>
  </React.StrictMode>
);

reportWebVitals();
